import type { FC } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { Box, Container, Typography, Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

export const Account: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  // Cancel returns to wherever the user came from. location.key === 'default'
  // means they landed on /account directly (typed URL / refresh) with no in-app
  // history to go back to — fall back to the app home instead of a dead end.
  const handleCancel = () => {
    if (location.key && location.key !== 'default') {
      navigate(-1);
    } else {
      navigate('/');
    }
  };

  return (
    <Box
      sx={{
        backgroundColor: 'background.paper',
        flexGrow: 1
      }}
    >
      <Container
        maxWidth="lg"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%'
        }}
      >
        <Box sx={{ py: 4 }}>
          <Box
            sx={{
              alignItems: 'center',
              display: 'flex'
            }}
          >
            <Typography
              color="textPrimary"
              variant="h4"
              sx={{ flexGrow: 1 }}
            >
              Account Settings
            </Typography>
            <Button variant="outlined" onClick={handleCancel}>
              {t('cancel')}
            </Button>
          </Box>
          {/* <Tabs
            allowScrollButtonsMobile
            sx={{ mt: 2 }}
            value={tabs.findIndex((tab) => tab.href === location.pathname)}
            variant="scrollable"
          >
            {tabs.map((option) => (
              <Tab
                component={RouterLink}
                key={option.href}
                label={option.label}
                to={option.href}
              />
            ))}
          </Tabs> */}
          {/* <Divider /> */}
        </Box>
        <Outlet />
      </Container>
    </Box>
  );
};
